<template>
    <div class="chartComp">
        <div class="toolbar">
            <div class="div_btns">
                <button :class="[activeBtn == 'day'?'btn_orange':'btn_white']" @click="setPeriod('day')">День</button>
                <button :class="[activeBtn == 'week'?'btn_orange':'btn_white']" @click="setPeriod('week')">Неделя
                </button>
                <button :class="[activeBtn == 'month'?'btn_orange':'btn_white']" @click="setPeriod('month')">Месяц
                </button>
            </div>
            <div class="div_year_filter">
                <input
                        v-model="yearFilter"
                        type="number"
                        :class="['year_filter_input']"
                        placeholder="Год"
                />
                <button :class="[activeBtn == 'year'?'btn_orange':'btn_white']" @click="setPeriod('year')">Год</button>
            </div>
            <div class="div_info">
                <span>Всего: {{orderMassage.total.massage}} мин.</span>
            </div>
            <button v-if="urlReport" :class="['btn_orange']" @click="downladReport">Скачать Excel</button>
            <button v-if="!urlReport" :class="['btn_white']" @click="getReport">Сформировать Excel</button>
        </div>
        <line-chart
                :labels="orderMassage.labels"
                :datasets="orderMassage.datasets"
        />
    </div>
</template>

<script>

export default {
  name: 'chartComp',
  data: function () {
    return {
      moduleName: 'stat',
      activeBtn: 'day',
      yearFilter: new Date().getFullYear()
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOrdersMassage`, { params: { period: 'day' } })
  },
  components: {},
  computed: {
    orderMassage: function () {
      let massage = this.$store.getters[`${this.moduleName}/getMassage`]
      return {
        total: massage.total,
        labels: massage.labels,
        datasets: [
          {
            label: '',
            backgroundColor: '#ff8200',
            data: massage.massages
          }
        ]
      }
    },
    urlReport: function () {
      return this.$store.getters[`${this.moduleName}/getUrlMassage`]
    }
  },
  methods: {
    setPeriod (period) {
      this.activeBtn = period
      if (this.activeBtn === 'year' && !this.yearFilter) {
        this.yearFilter = new Date().getFullYear()
      }
      this.$store.dispatch(`${this.moduleName}/getOrdersMassage`, { params: { period: period, yearFilter: this.yearFilter } })
      this.$store.commit(`${this.moduleName}/setUrlMassage`, '')
    },
    getReport () {
      this.$store.dispatch(`${this.moduleName}/getOrdersMassageReport`, { params: { period: this.activeBtn, yearFilter: this.yearFilter } })
    },
    downladReport () {
      let url = `${this.$http.server_api_url}/${this.urlReport}`
      window.open(url, '_blank')
      this.$store.commit(`${this.moduleName}/setUrlMassage`, '')
    }
  }
}
</script>

<style scoped lang="scss">
    .year_filter_input {
        object-fit: contain;
        border-radius: 9px;
        background-color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: -0.5px;
        color: #ff8200;
        border: 2px solid #ff8200;
        text-align: center;
        width: 80px;
    }

    .year_filter_input::placeholder {
        color: #ff8200;
        font-size: 16px;
    }

    .chartComp {
        margin: 32px;
    }

    .toolbar {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: auto 1fr auto;
        grid-column-gap: 10px;
        margin-bottom: 15px;
        grid-row-gap: 15px;
    }

    .div_btns {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: auto auto auto auto;
        grid-column-gap: 10px;
    }

    .div_year_filter {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: auto auto auto auto;
        grid-column-gap: 10px;
        width: 300px;
    }

    .btn_orange {
        width: 100%;
        height: 36px;
        object-fit: contain;
        border-radius: 9px;
        background-color: #ff8200;
        object-fit: contain;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: -0.5px;
        color: #ffffff;
        cursor: pointer;
    }

    ;
    .btn_white {
        width: 100%;
        height: 36px;
        object-fit: contain;
        border-radius: 9px;
        background-color: #ffffff;
        object-fit: contain;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: -0.5px;
        color: #ff8200;
        border: 2px solid #ff8200;
        cursor: pointer;
    }

    .div_year_filter {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: auto auto auto auto;
        grid-column-gap: 10px;
        width: 160px;
    }

    .div_info {
        margin: auto 0;
        text-align: center;
    }

    .div_info span {
        margin-left: 10px;
    }

    @media screen and (max-width: 1140px) {
        .toolbar {
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            grid-row-gap: 15px;
        }
    }

    @media screen and (max-width: 960px) {
    }

    @media screen and (max-width: 720px) {
    }

    @media screen and (max-width: 540px) {
    }

    @media screen and (max-width: 480px) {
    }

    @media screen and (max-width: 320px) {
    }
</style>
